import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private baseService: BaseService) { }

  createUser(data: any): Observable<any> {
    return this.baseService.post('user/register', data);
  }

  updateUser(data: any): Observable<any> {
    return this.baseService.post(`user/update/${data?.userId}`, data);
  }

  getAllUsers(): Observable<any> {
    return this.baseService.get('user/list');
  }

  getUsersWithFilters(filters?: {
    startDate?: string,
    endDate?: string,
    state?: string,
    city?: string,
    startScanCount?: string,
    endScanCount?: string,
    search?: string,
    page?: number,
    pageSize?: number
  }): Observable<any> {
    let url = 'user/list';
    const params: string[] = [];

    if (filters) {
      // Add pagination parameters
      if (filters.page !== undefined) {
        params.push(`page=${filters.page}`);
      }
      if (filters.pageSize !== undefined) {
        params.push(`limit=${filters.pageSize}`);  // Changed from pageSize to limit
      }

      // Add filter parameters
      if (filters.startDate) {
        params.push(`startDate=${filters.startDate}`);
      }
      if (filters.endDate) {
        params.push(`endDate=${filters.endDate}`);
      }
      if (filters.state) {
        const trimmedState = filters.state.trim();
        if (trimmedState) {
          params.push(`state=${encodeURIComponent(trimmedState)}`);
        }
      }
      if (filters.city) {
        const trimmedCity = filters.city.trim();
        if (trimmedCity) {
          params.push(`city=${encodeURIComponent(trimmedCity)}`);
        }
      }
      if (filters.startScanCount) {
        params.push(`startScan=${filters.startScanCount}`);
      }
      if (filters.endScanCount) {
        params.push(`endScan=${filters.endScanCount}`);
      }
      if (filters.search) {
        params.push(`search=${encodeURIComponent(filters.search.trim())}`);
      }
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this.baseService.get(url);
  }

  getUserById(data: any): Observable<any> {
    return this.baseService.get('user/account', data);
  }

  deleteUser(data: any): Observable<any> {
    return this.baseService.delete('user/delete', data);
  }

  getState(): Observable<any> {
    return this.baseService.get('user/getState');
  }

  getCity(data: any): Observable<any> {
    return this.baseService.get(`user/getCity/${data}`);
  }

  deleteState(id: any): Observable<any> {
    return this.baseService.delete('user/deleteState', id)
  }

  deleteCity(id: any): Observable<any> {
    return this.baseService.delete('user/deleteCity', id)
  }

  editState(data: any): Observable<any> {
    return this.baseService.patch(`user/editState/${data?.id}`, data)
  }

  editCity(data: any): Observable<any> {
    return this.baseService.patch(`user/editCity/${data?.id}`, data)
  }

  addCity(data: any): Observable<any> {
    return this.baseService.post('user/addCity', data)
  }

  addState(data: any): Observable<any> {
    return this.baseService.post('user/addState', data)
  }

  generateReport(data: any): Observable<any> {
    return this.baseService.post('registeredProducts/generateReports', data);
  }

  sendBulkNotification(data: FormData | any): Observable<any> {
    return this.baseService.post('user/sendBulkNotification', data);
  }
}
